import React from "react";
import { View } from "react-native";
import { useRouter } from "expo-router";
import TposButton from "@/app/components/Buttons/TposButton";
import { TposIcon } from "@/app/components/Icons/TposIcon";

import { printerStyle as styles } from "./styles";

const PrintSettings = () => {
  const { navigate } = useRouter();

  return (
    <View style={styles.container}>
      <View style={styles.printerInputContainer}></View>
      <View style={styles.testPrintButtonContainer}>
        <TposButton
          onPress={() => {
            navigate("./testprinter");
          }}
          disabled={false}
          buttonText="Test Print"
          styles={{
            buttonContainer: styles.testPrintButton,
          }}
        >
          <TposIcon icon={require("@/assets/test-print.png")} />
        </TposButton>
      </View>
    </View>
  );
};

export default PrintSettings;
